// extracted by mini-css-extract-plugin
module.exports = {"interviewSummary":"styles-module__interviewSummary___3OuVV"};